
























import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { BillingPeriodWithEmployersResponse, BillingPeriodEmployer } from "@/shared/types";
import * as _ from "lodash";

@Component({
  components: {
    Button,
    GenericLoadingSpinner
  }
})

export default class PartnerMonthlyEmployerReport extends Vue {
  @Prop() partnerId: number;
  @Prop() selectableBillingPeriods: BillingPeriodWithEmployersResponse[];
  @Prop() employers: BillingPeriodEmployer[];
  @Prop() periodsLoaded: boolean;
  @Prop() loadBillingPeriodsByPartner: (args: { partnerId: number }) => Promise<void>;
  @Prop() resetBillingPeriodsState: () => Promise<void>;
  @Prop() setPeriod: (arg: {billingPeriodId: number, reportName: string}) => Promise<void>;
  @Prop() setEmployer: (arg: {employerId: number, employerName: string}) => Promise<void>;
  @Prop() downloadReportForPartner: ( args: {
    periodId: number,
    periodName: string,
    partnerId: number,
    employerId?: number,
    employerName?: string
  }) => Promise<void>;

  selectedPeriod: BillingPeriodWithEmployersResponse = null;
  selectedEmployer: BillingPeriodEmployer = null;

  get periodName (): null | string { return _.get(this.selectedPeriod, "periodName", null); }
  get periodValue (): null | number { return _.get(this.selectedPeriod, "periodId", null); }
  get employerName (): null | string { return _.get(this.selectedEmployer, "employerName", null); }
  get employerValue (): null | number { return _.get(this.selectedEmployer, "employerId", null); }

  @Watch("selectedPeriod")
  onPeriodSelected () {
    this.setPeriod({
      billingPeriodId: this.periodValue,
      reportName: this.periodName
    });
  }

  @Watch("selectedEmployer")
  onEmployerSelected () {
    this.setEmployer({
      employerId: this.employerValue,
      employerName: this.employerName
    });
  }

  get hasSpecifiedReport () { return Boolean(this.selectedPeriod); }
  get hasMonthlyBillingPeriods () { return this.selectableBillingPeriods && this.selectableBillingPeriods.length > 0; }

  mounted () {
    this.resetBillingPeriodsState();
    if (this.partnerId) {
      this.loadBillingPeriodsByPartner({ partnerId: this.partnerId });
    }
  }

  downloadCsv () {
    if (!this.hasSpecifiedReport) {
      return;
    }

    this.downloadReportForPartner({
      periodId: this.selectedPeriod.periodId,
      periodName: this.selectedPeriod.periodName,
      partnerId: this.partnerId,
      employerId: this.employerValue,
      employerName: this.employerName
    });
  }
}


